import React from "react";
import { Box, Container, Typography, useTheme, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import CoachPolicy from "./CoachPolicy";
import CoachSlider from "./CoachSlider";

export default function CoachesSct({ coachesData, coachesStatus }) {
  const navigate = useNavigate();
  const theme = useTheme();

  const isLoading = coachesStatus === "pending";

  return (
    <Box
      sx={{
        width: "100%",
        py: { xs: 4, md: 6 },
        pb: "5rem !important",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xxl">
        {/* Header Section */}
        <Box sx={{ mb: 4 }}>
          <Typography
            onClick={() => navigate("/coaches")}
            variant="h6"
            sx={{
              fontWeight: 800,
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 1,
              cursor: "pointer",
            }}
          >
            مربی های پیشنهادی
          </Typography>
          <Typography variant="body2" color="text.secondary">
            بهترین مربی های پیشنهادی طبق آنالیز شما
          </Typography>
        </Box>

        {/* Coach Slider or Skeleton */}
        {isLoading ? (
          <Box sx={{ display: "flex", gap: 3, overflow: "hidden", mb: 4 }}>
            {[1, 2, 3, 4].map((item) => (
              <Box
                key={item}
                sx={{ width: { xs: 280, md: 320 }, flexShrink: 0 }}
              >
                {/* Adjust the height/border radius based on how your Coach cards actually look */}
                <Skeleton
                  variant="rectangular"
                  height={250}
                  sx={{ borderRadius: 3 }}
                />
                <Skeleton
                  variant="text"
                  sx={{ mt: 2, fontSize: "1.5rem" }}
                  width="70%"
                />
                <Skeleton
                  variant="text"
                  sx={{ fontSize: "1rem" }}
                  width="40%"
                />
              </Box>
            ))}
          </Box>
        ) : (
          <CoachSlider coachesData={coachesData} />
        )}

        {/* Coach Policy */}
        <CoachPolicy />
      </Container>
    </Box>
  );
}
